document.addEventListener("DOMContentLoaded", () => {
    navMobileScripts();
})

const navMobileScripts = () => {
    const navSelector = "._nav-mobile-66e02c9d";
    const closeSelector = "._cerrar-nav-mobile";
    const navMob = document.querySelector(navSelector);
    const close = document.querySelector(closeSelector); 

    window.addEventListener("showMenuMobile", () => {
        navMob.classList.add("show");
    });
    
    close.addEventListener("click", ()=> {
        navMob.classList.remove("show");
    });
}